import { render, staticRenderFns } from "./stepDadosCooperado.vue?vue&type=template&id=5fd20bff&scoped=true"
import script from "./stepDadosCooperado.vue?vue&type=script&lang=ts"
export * from "./stepDadosCooperado.vue?vue&type=script&lang=ts"
import style0 from "./stepDadosCooperado.vue?vue&type=style&index=0&id=5fd20bff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd20bff",
  null
  
)

export default component.exports